import { render, staticRenderFns } from "./NearByCard.vue?vue&type=template&id=431abbfa"
import script from "./NearByCard.vue?vue&type=script&lang=js"
export * from "./NearByCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/common/Button.vue').default,NearBy: require('/vercel/path0/components/partials/NearBy.vue').default,MapboxMapNearBy: require('/vercel/path0/components/partials/MapboxMapNearBy.vue').default,GoogleMapNearBy: require('/vercel/path0/components/partials/GoogleMapNearBy.vue').default,NearByMobile: require('/vercel/path0/components/partials/NearByMobile.vue').default,ModalScreen: require('/vercel/path0/components/common/ModalScreen.vue').default})
